<template lang="pug">
  event-container(v-slot="{ event }")
    event-register(:event="event")
</template>

<script>
import EventContainer from '../components/EventContainer.vue';
import EventRegister from '../components/event-register/EventRegister.vue';

export default {
  name: 'EventRegisterView',
  components: {
    EventContainer,
    EventRegister,
  },
};
</script>
